import http, { download, uploadCfg } from "../../utils/HttpUtils";

// //菜单信息
// export interface Auth2MenuDetail {
//     appCode: string,
//     appName: string,
//     children: Auth2MenuDetail[],
//     code: string,
//     createTime: string,
//     createUser: string,
//     deleteFlag: number,
//     id: string,
//     linkUrl: string,
//     menuTypeCode: string,
//     menuTypeName: string,
//     name: string,
//     note: string,
//     orderNum: number,
//     params: string,
//     pcode: string,
//     status: string,
//     updateTime: string,
//     updateUser: string,
// }

// export interface Auth2UserInfo {
//     lastVisitTime: string,     //最后返回时间
//     loginTime: string,         //登陆时间
//     menus: {
//         [key: string]: Auth2MenuDetail[]   //用户菜单列表
//     },
//     portals: string[],        //用户门户列表
//     resources: string[],       //用户资源列表
//     roles: string[],            //用户角色列表
//     shops: string[],            //用户门店列表
//     userCode: string,
//     userName: string,
// }

// export interface Auth2User {
//     userCode: string;
//     userPassword: string;
//     sourceApp?: string,
//     token?: string
// }

// 鉴权2.0 auth
class LoginServiceAuth2 {
    //账号密码登录  返回token
    async Login(user, config) {
        const apiUrl = "/portal/auth/login/login";
        return await http.post(apiUrl, user, config);
    }
    //登出
    async Logout() {
        const apiUrl = "/portal/auth/login/logout";
        return await http.post(apiUrl);
    }

    /**
     * 根据token查询所有用户权限信息
     * @param data { sourceApp?: string, token: string }
     */
    async VerifyInfo(data) {
        const apiUrl = "/portal/auth/login/verify";
        return http.post(apiUrl, data)
    }
    //记录app登陆信息
    async recordAppLoginInfo(appCode, userCode) {
        const apiUrl = `/portal/log/appAccess/recordAppLoginInfo/${appCode}/${userCode}`;
        return http.post(apiUrl);
    }
    //记录app登出信息
    async recordAppLogoutInfo(appCode, userCode) {
        const apiUrl = `/portal/log/appAccess/recordAppLogoutInfo/${appCode}/${userCode}`;
        return http.post(apiUrl);
    }
}

export const loginServiceAuth2 = new LoginServiceAuth2();
